import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { INacebelCode } from "../../utils/types/models";

export default createEntityReducer<INacebelCode>(Endpoint.NacebelCodes, Endpoint.NacebelCodesList);
